import { t as shopify_cart_default } from "./shopify-cart-ChiJJ022.js";
import { t as handleProductSections } from "./product-utils-CBxrtRYw.js";
//#region src/scripts/extenders/product-form.js
var ProductForm = class extends HTMLElement {
	constructor() {
		super();
		const form = this.querySelector("form");
		const addToCartButton = this.querySelector("#addToBagButton");
		const variantRadios = this.querySelectorAll(".variant-options__radio");
		const handleVariantSelect = (swatch, module, option) => {
			const variant = JSON.parse(document.querySelector(".variants-data").innerHTML).filter((variant) => variant.module.includes(module))[0].variants.filter((variant) => variant.title.includes(swatch) && variant.title.includes(option));
			const url = new URL(window.location.href);
			url.searchParams.set("variant", variant[0].id);
			history.replaceState({}, `variant-${variant[0].id}`, url.href);
			handleProductSections(url.href);
		};
		const handleVariantWithoutModule = (swatch, option) => {
			const variant = JSON.parse(document.querySelector(".variants-data").innerHTML).filter((variant) => variant.title.includes(swatch) && variant.title.includes(option));
			const url = new URL(window.location.href);
			url.searchParams.set("variant", variant[0].id);
			history.replaceState({}, `variant-${variant[0].id}`, url.href);
			handleProductSections(url.href);
		};
		const handleVariantWithoutModuleOrSwatch = (option) => {
			const variant = JSON.parse(document.querySelector(".variants-data").innerHTML)[0].variants.filter((variant) => variant.title.includes(option));
			const url = new URL(window.location.href);
			url.searchParams.set("variant", variant[0].id);
			history.replaceState({}, `variant-${variant[0].id}`, url.href);
			handleProductSections(url.href);
		};
		/**
		* Attach listener to the form submit buttons.
		*
		* @param event {object}
		*
		* @returns {boolean}
		*/
		const handleAddToCart = async (event) => {
			const formData = Object.fromEntries(new FormData(event.target).entries());
			if (formData.productVariant && form.checkValidity()) await shopify_cart_default.add(formData, addToCartButton);
		};
		if (form) form.addEventListener("submit", (event) => {
			event.preventDefault();
			handleAddToCart(event);
		});
		variantRadios.forEach((radio) => {
			radio.addEventListener("change", (e) => {
				if (e.target.checked) {
					const selectedSwatch = document.querySelector(".swatch__radio:checked")?.value;
					const selectedModule = document.querySelector(".module__radio:checked")?.dataset.moduleLetter;
					const selectedOption = e.target.value;
					if (selectedSwatch !== void 0 && selectedModule !== void 0 && selectedOption !== void 0) handleVariantSelect(selectedSwatch, selectedModule, selectedOption);
					else if (selectedSwatch !== void 0 && selectedOption !== void 0) handleVariantWithoutModule(selectedSwatch, selectedOption);
					else handleVariantWithoutModuleOrSwatch(selectedOption);
				}
			});
		});
	}
};
if (customElements.get("product-form") === void 0) customElements.define("product-form", ProductForm);
//#endregion
